<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/settings_sub.jpg" />
      <h1 class="">パスワード変更</h1>
    </div>
    <div class="detail-cart text-center my-5 border box-p-20">
      <h2 class="mb-2">新しいパスワードを入力してください</h2>
      <p>
        <input
          v-model="newPassword"
          ref="newPassword"
          type="password"
          style="border: thin #ccc solid"
          maxlength="12"
          size="30"
        />
      </p>
      <p>
        例）123abc456def<br />・半角英字と数字を組み合わせて8桁以上12桁以下の入力をお願いします。
      </p>
      <h2 class="mb-2 mt-5">パスワードの再入力をお願いします</h2>
      <p>
        <input
          v-model="chkPassword"
          ref="chkPassword"
          type="password"
          style="border: thin #ccc solid"
          maxlength="12"
          size="30"
        />
      </p>
      <p>確認のため、入力したパスワードを再度入力してください。</p>
    </div>
    <div class="my-5 text-center">
      <button v-on:click="setEvent" class="btn d-inline-block">
        パスワードを変更する
      </button>
    </div>
    <div class="mb-5 text-center">
      <router-link to="/settings" class="btn d-inline-block"
        >会員情報を変更へ戻る</router-link
      >
    </div>
  </section>
</template>

<style>
@media screen and (min-width: 700px) {
  .detail-cart input[type="password"] {
    width: 50%;
  }
}
</style>

<script>
import Request from "@/modules/Request";
import Message from "@/modules/Message";
let request = new Request();
export default {
  data() {
    return {
      newPassword: "",
      chkPassword: "",
    };
  },
  mounted() {
    this.$refs.newPassword.focus();
    window.scroll(0, 0);
  },
  methods: {
    setEvent() {
      if (this.newPassword == "") {
        //新しいパスワードがなければ何もしない
        return;
      }

      if (this.chkPassword == "") {
        Message.error().fire({
          title: "確認パスワードが未入力です。",
          onAfterClose: () => {
            this.$refs.chkPassword.focus();
          },
        });
        return;
      }

      //入力確認
      if (this.newPassword.match(/[^a-zA-Z0-9]/)) {
        Message.error().fire({
          title: "新規パスワードは半角英数字のみを入力して下さい。",
          onAfterClose: () => {
            this.$refs.newPassword.focus();
          },
        });
        return;
      }

      if (this.newPassword.length < 8 || this.newPassword.length > 12) {
        Message.error().fire({
          title: "新規パスワードは8桁以上、12桁以内で入力して下さい。",
          onAfterClose: () => {
            this.$refs.newPassword.focus();
          },
        });
        return;
      }
      //check() return
      if (!this.newPassword.match(/([0-9].*[a-zA-Z]|[a-zA-Z].*[0-9])/)) {
        Message.error().fire({
          title: "新規パスワードは半角英字と数字を組み合わせて入力して下さい。",
          onAfterClose: () => {
            this.$refs.newPassword.focus();
          },
        });
        return;
      }

      if (this.newPassword != this.chkPassword) {
        this.$refs.chkPassword.focus();
        Message.error().fire({
          title: "確認パスワードに誤りがあります。",
          onAfterClose: () => {
            this.$refs.chkPassword.focus();
          },
        });
        return;
      }

      //パスワード変更処理
      Message.confirm()
        .fire({
          title: "パスワードを変更します。よろしいですか？",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let postParams = [this.newPassword];
            let requestParams = request.createParams(
              "webMdlMemberInfo",
              "updPassword",
              postParams
            );
            request
              .create()
              .post("", requestParams)
              .then((data) => {
                Message.success().fire({
                  title: data.msg,
                  position: "center",
                  showConfirmButton: true,
                  timer: null,
                  toast: false,
                });
              });
          }
        });
    },
  },
};
</script>
